import * as React from 'react';
const styles = require('./index.less');

const Divider = () => {
  return (
    <div className={styles.divider}>
      <div className={styles.inner}>
        <div className={styles.arrow} />
        <div className={styles.line} />
      </div>
    </div>
  );
};

export default Divider;
